import positions from '../constants/positions';

const { BOTTOM, TOP } = positions;

const getElementSideToScrollInContainer = (element, scrollContainer) => {
  const { height, top: elementTop, bottom: elementBottom } = element.getBoundingClientRect();
  const {
    height: containerHeight,
    top: containerTop,
    bottom: containerBottom,
  } = scrollContainer.getBoundingClientRect();

  const higherThanContainer = height >= containerHeight;

  if (elementTop < containerTop || higherThanContainer) {
    return TOP;
  }

  if (elementBottom - containerBottom > 0) {
    return BOTTOM;
  }

  return null;
};

export default getElementSideToScrollInContainer;
